<template>
  <div class="TestPrice" v-title data-title="水产价格测算工具">
    <div class="padding4 bc-white">有{{count||0}}人测过价格</div>
    <div class="pr5">
      <div class="row mt7 align-items-stretch">
        <div class="query-label">品种</div>
        <div @click="changeType('1')" class="query-cate col" :class="params.quoteType==1?'active':''">
          小龙虾
          <van-icon v-if="params.quoteType==1" name="checked" class="cate-checked" />
        </div>
        <div @click="changeType('2')" class="query-cate col ml2" :class="params.quoteType==2?'active':''">
          螃蟹
          <van-icon v-if="params.quoteType==2" name="checked" class="cate-checked" />
        </div>
      </div>
      <div @click="showPickerAction('cate')" class="row mt10 align-items-stretch">
        <div class="query-label">行话</div>
        <div class="flex-1 query-selected">
          {{params.categoryText}}
          <span v-if="!params.categoryText" class="fc-suppl">请选择</span>
          <van-icon class="ml1" name="arrow-down" />
        </div>

        <!-- <div class="query-more row vertical justify-content-center">
          <div>更多</div>
          <van-icon name="arrow-down" />
        </div> -->
      </div>
      <div @click="showAreaAction('area')" class="row mt10 align-items-stretch">
        <div class="query-label">地区</div>
        <div class="flex-1 query-selected row align-items-center justify-content-center">
          <div>{{params.provinceText||'全国'}}</div>
          <van-icon class="ml1" name="arrow-down" />
          <!-- <van-icon v-if="params.provinceText" @click.stop="clearValue('provinceText', 'provinceCode')" class="fc-suppl ml2" name="close" /> -->
        </div>
        <!-- <div class="query-more row vertical justify-content-center">
          <div>更多</div>
          <van-icon name="arrow-down" />
        </div> -->
      </div>
      <div @click="showDateAction('date')" class="row mt10 align-items-stretch">
        <div class="query-label">时间</div>
        <div class="flex-1 query-selected row align-items-center justify-content-center">
          <div>{{params.queryDateText||'全部'}}</div>
          <van-icon class="ml1" name="arrow-down" />
          <!-- <van-icon v-if="params.queryDateText" @click.stop="clearValue('queryDateText', 'queryDate')" class="fc-suppl ml2" name="close" /> -->
        </div>
        <!-- <div class="query-more row vertical justify-content-center">
          <div>更多</div>
          <van-icon name="arrow-down" />
        </div> -->
      </div>
      <div class="row mt10 align-items-stretch">
        <div class="query-label">价格<span class="fs1">(元)</span></div>
        <div class="flex-1">
          <input class="w100p query-selected query-input" placeholder="请输入" v-model="params.price">
        </div>
        <!-- <div class="query-more row vertical justify-content-center">
          元
        </div> -->
      </div>
    </div>
    <div @click="query" class="query-btn row justify-content-center align-items-center">
      查询
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="options"
        @cancel="showPicker = false"
        @confirm="confirmPicker"
      />
    </van-popup>
    <van-popup v-model="showArea" position="bottom">
      <van-area
        :value="params.area"
        title="地区选择"
        :columns-num="1"
        :area-list="areaList"
        :columns-placeholder="['全国', '请选择', '请选择']"
        @cancel="showArea = false"
        @confirm="confirmArea"
      />
    </van-popup>
    <van-popup v-model="showDate" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        @confirm="confirmDate"
        @cancel="showDate = false"
        :max-date="maxDate"
      />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue';
import wx from 'weixin-js-sdk';
import {
  sendRequest, getregion, quoteDict, getstatistics, getWxParams,
} from '../../network/NetworkAccessor';
import storage from '../../uitls/cacheUtil';
import promisify from '../../uitls/promisify';
import { isQYWeixin, isWeixin } from '../../uitls/checkUtil';

// import config from '../../config';
const shareImage = `${window.location.protocol}//${window.location.host}/images/share/important-notice.png`;
const dicts = {};
export default Vue.extend({
  name: 'TestPrice',
  components: {},
  data() {
    return {
      isWeixin: isWeixin(),
      isQYWeixin: isQYWeixin(),
      maxDate: new Date(),
      count: 0,
      params: {
        quoteType: '1',
      },
      options: [],
      clickPicker: '',
      showPicker: false,
      showArea: false,
      showDate: false,
      areaList: {},
      currentDate: new Date(),
    };
  },
  methods: {
    clearValue(field = '', field1 = '') {
      if (field) {
        this.$set(this.params, field, '');
      }
      if (field1) {
        this.$set(this.params, field1, '');
      }
    },
    showPickerAction(type = '') {
      if (!this.params.quoteType) {
        this.$dialog.alert({
          message: '请先选择品种',
        });
        return;
      }
      if (!this.options || this.options.length < 1) {
        this.getDict();
      }
      this.showPicker = true;
      this.clickPicker = type;
    },
    showAreaAction(type = '') {
      this.getRegion();
      this.showArea = true;
      this.clickPicker = type;
    },
    showDateAction(type = '') {
      this.showDate = true;
      this.clickPicker = type;
    },
    changeType(cate = '1') {
      this.options = [];
      // if (cate === this.params.quoteType) {
      //   this.$set(this.params, 'quoteType', '');
      //   return;
      // }
      if (cate !== this.params.quoteType) {
        this.$set(this.params, 'categoryCode', '');
        this.$set(this.params, 'categoryText', '');
      }
      this.$set(this.params, 'quoteType', cate);
    },
    confirmPicker(val = {}) {
      this.$set(this.params, 'categoryCode', val.value);
      this.$set(this.params, 'categoryText', val.value ? val.text : '');
      this.showPicker = false;
      this.clickPicker = '';
    },
    confirmArea(val = []) {
      const [province = {}] = val;
      this.$set(this.params, 'provinceCode', province.code);
      this.$set(this.params, 'provinceText', province.name);
      this.showArea = false;
      this.clickPicker = '';
    },
    confirmDate(val) {
      console.log(val);
      // const [province = {}] = val;
      let date = {};
      if (val) {
        date = this.formatDate(val);
      }
      this.$set(this.params, 'queryDate', date.value || '');
      this.$set(this.params, 'queryDateText', date.text || '');
      this.showDate = false;
      this.clickPicker = '';
    },
    formatDate(date) {
      if (!date) {
        return {};
      }
      const month = date.getMonth() + 1;
      const monthStr = month > 9 ? month : `0${month}`;
      const d = date.getDate();
      const dStr = d > 9 ? d : `0${d}`;
      const datestr = `${date.getFullYear()}${monthStr}${dStr}`;
      const text = `${date.getFullYear()}-${month}-${d}`;
      // console.log(datestr);
      return {
        value: datestr,
        text,
      };
    },
    changeArea() {

    },
    getDict() {
      sendRequest(quoteDict).then((res = {}) => {
        dicts['1'] = (res.crayfish || {}).categories || [];
        dicts['1'].unshift({
          value: '',
          text: '请选择',
        });
        dicts['2'] = (res.crab || {}).categories || [];
        dicts['2'].unshift({
          value: '',
          text: '请选择',
        });
        this.options = dicts[this.params.quoteType];
      }).catch((e) => {
        // this.$dialog.alert({
        //   message: e.message,
        // });
      });
    },
    getRegion(pcode = '') {
      if (this.areaList && Object.keys(this.areaList.province_list || {}).length > 10) {
        return;
      }
      sendRequest(getregion, { pcode }).then((res = []) => {
        const provinceList = {};
        (res || []).forEach((obj) => {
          provinceList[obj.code] = obj.name;
        });
        this.$set(this.areaList, 'province_list', provinceList);
      }).catch((e) => {
        // this.$dialog.alert({
        //   message: e.message,
        // });
      });
    },
    query() {
      const {
        quoteType, categoryCode, price,
      } = this.params;
      if (!(quoteType && categoryCode && price)) {
        this.$dialog.alert({
          message: '请填写行话、价格',
        });
        return;
      }
      storage.session.set('TEST_PARAMS', this.params);
      // let params = '';
      // // eslint-disable-next-line no-restricted-syntax
      // for (const key in this.params) {
      //   // eslint-disable-next-line no-prototype-builtins
      //   if (this.params.hasOwnProperty(key)) {
      //     const val = this.params[key];
      //     params += `${key}_${val}|`;
      //   }
      // }
      this.$router.push(`/test/price/result/${JSON.stringify(this.params)}`);
    },
    getStatistics() {
      sendRequest(getstatistics, { type: 2 }).then((res) => {
        this.count = res || 0;
      }).catch((e) => {
        // this.$dialog.alert({
        //   message: e,
        // });
      });
    },
    configWx() {
      if (wx) {
        // const wxp = this.$cookies.get('q_wx_p') || '{}';
        sendRequest(getWxParams, {
          url: window.location.href,
          source: this.isQYWeixin ? 'qywx' : 'wx',
        }).then((res) => {
          console.log(res, 'res');
          return res || {};
        }).catch((error) => {
          console.log(error, 'error');
          return {};
        }).then((info = {}) => {
          wx.config({
            // debug: storage.local.get('type') === 4, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: info.appId, // 必填，公众号的唯一标识
            timestamp: info.timestamp, // 必填，生成签名的时间戳
            nonceStr: info.noncestr, // 必填，生成签名的随机串
            signature: info.signature, // 必填，签名
            jsApiList: ['updateAppMessageShareData',
              'updateTimelineShareData',
              'onMenuShareAppMessage',
              'onMenuShareWechat'], // 必填，需要使用的JS接口列表
          });
          wx.ready(() => {
            console.log(wx, 'ready==============');
            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
            const zf = {
              title: '水产价格测算工具', // 分享标题
              desc: '精准测算各地龙虾螃蟹价格，10万人正在使用', // 分享描述
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: `${shareImage}`, // 分享图标
            };
            const pyq = {
              title: '水产价格测算工具 | 精准测算各地龙虾螃蟹价格，10万人正在使用', // 分享标题
              link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: `${shareImage}`, // 分享图标
            };
            promisify(wx.checkJsApi)({
              jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            }).then((res) => {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              // 个人微信内转发会话
              promisify(wx.updateAppMessageShareData)(zf).then(() => {
                console.log('success......');
              }).catch((error1) => {
                console.log(error1, 'error1-------');
              });
              // 个人微信内分享朋友圈
              promisify(wx.updateTimelineShareData)(pyq).then(() => {
                console.log('success......');
              }).catch((error1) => {
                console.log(error1, 'error1-------');
              });
            }).catch((error) => {
              console.log(error, 'error-------');
            });
            promisify(wx.checkJsApi)({
              jsApiList: ['onMenuShareAppMessage',
                'onMenuShareWechat'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
            }).then((res) => {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              // 企业微信内转发会话
              promisify(wx.onMenuShareAppMessage)(zf).then(() => {
                console.log('success......');
              }).catch((error1) => {
                console.log(error1, 'error1-------');
              });
              // 企业微信内转发个人微信会话
              promisify(wx.onMenuShareWechat)(zf).then(() => {
                console.log('success......');
              }).catch((error1) => {
                console.log(error1, 'error1-------');
              });
            }).catch((error) => {
              console.log(error, 'error-------');
            });
          });
          wx.error((error) => {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            console.log(wx, 'error==============');
          });
        });
      }
    },
  },
  created() {
    this.getStatistics();
    const params = (storage.session.get('TEST_PARAMS') || {});
    params.quoteType = params.quoteType || '1';
    this.params = params;
    this.configWx();
  },
});
</script>
<style scoped>
.TestPrice {
  min-height: 100vh;
  background-image: url('../../assets/bg3.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 30px;
}
.query-label {
  color: #ffffff;
  background-color: #2027ac;
  font-weight: bold;
  height: 50px;
  /* padding: 0 15px; */
  line-height: 50px;
  font-size: 16px;
  text-align: center;
  width: 90px;
}
.query-cate {
  color: #000000;
  background-color: #ffffff;
  min-width: 100px;
  /* margin-right: 5px; */
  height: 50px;
  line-height: 50px;
  font-size: 14px;
}
.query-cate.active {
  color: #2027ac;
  background-color: #e7e6ff;
  box-shadow: 2px 6px 8px #7d7979;
}
.query-selected {
  background-color: #ffffff;
  color: #000000;
  line-height: 50px;
  padding: 0;
  border: 0!important;
  text-align: center;
  border-radius: 0;
}
.query-input {
  width: 100%!important;
}
input:focus{
  border: 0!important;
}
.query-more {
  /* padding: 0 5px; */
  width: 38px;
  font-size: 13px;
  color: #2027ac;
  background-color: #e7e6ff;
}
.query-btn {
  border: 6px solid #2027ac;
  background-color: #ffffff;
  width: 110px;
  height: 110px;
  /* line-height: 110px; */
  border-radius: 50%;
  color: #2027ac;
  font-weight: 900;
  font-size: 25px;
  margin: 0 auto;
  margin-top: 10vh;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.5);
}
.cate-checked {
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(10%, -30%);
  color: #2027ac;
  font-size: 25px;
  z-index: 2;
}
</style>
